import M from 'backbone.marionette'
import { showModal } from '../../utils/bootstrap/modal';
import { CreatePunch } from './create';
import Backbone from 'backbone';

export const CreatePunchButton = M.View.extend({
    template: _.template('<button id="btajoutPuch" class="btn btn-default">Ajouter un temps de suivi</button>'),
    events: {
        'click #btajoutPuch':'onClick',
    },
    onClick: function(){
        const v = new CreatePunch({
            model : new Backbone.Model({
                etudiant_id: this.getOption('etudiantId'),
                etudianteval_id: this.getOption('etudiantevalId'),
                enseignant_id: this.getOption('enseignantId'),
            })
        });
        showModal('Nouveau suivi', v);
    }
})